(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('AlarmsAsignController', AlarmsAsignController);
    

    AlarmsAsignController.$inject = [
  
    ];

     function AlarmsAsignController(){
        // jshint maxstatements:false

        var row = { 'type' : 'Zona', 
            //'type' : 'Zona', 
            'entity': 'Vehículo', 
            'asignedTo' : 'Plataformas',
            'name' : 'Primera alarma',
            'description' : 'Lorem ipsum dolor sit amet consecteur adipiscing elit',  
            'active' : 'Activada', 
            'actions' : 'editar | eliminar'
        };
        
        var vm = this;
        vm.gridData = [];
        vm.gridOptions = {
             columnDefs: [

                {
                    field: 'type',
                    displayName: 'Tipo',
                    minWidth: 75,
                    maxWidth: 100,
                    resizable: true
                },

                {
                    field: 'entity',
                    displayName: 'Entidad',
                    minWidth: 75,
                    maxWidth: 150,
                    resizable: true
                },

                {
                    field: 'name',
                    displayName: 'Nombre',
                    minWidth: 75,
                    maxWidth: 150,
                    resizable: true
                },

                {
                    field: 'description',
                    displayName: 'Descripción',
                    resizable: true
                },

                {
                    field: 'asignedTo',
                    displayName: 'Asignado a',
                    minWidth: 75,
                    maxWidth: 150,
                    resizable: true
                },



                {
                    field: 'active',
                    displayName: 'Activada',
                    minWidth: 75,
                    maxWidth: 150,
                    resizable: true
                },

                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 75,
                    maxWidth: 150,
                    resizable: true
                }

             ],

             data: vm.gridData,

        };

        (function () {
            loadData();
        })();

        function loadData(){
            for(var i = 0; i < 15; i++){
                vm.gridData.push(row);
            }
        }
    }

})();